<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="center">
    <button mat-raised-button color="primary" style="width: 100px;" (click)="clickConfirm()">Si</button>
    <button mat-stroked-button color="primary" style="width: 100px;" (click)="clickReject()">No</button>
</div>